import { BannerIconCollection } from '@/models/BannerIcon';
import { BannerCollection } from '@/models/Banner';

export default {
    namespaced: true,
    state: {
        icons: {
            error: null,
            loaded: false,
            collection: null,
        },
        eventInfoboxes: {
            loaded: false,
            collection: null,
        },
        bannerTypes: [
            { type: 'commercial_large', text: 'Werbung gross', filterPreSelect: true },
            { type: 'commercial_small', text: 'Kulturpartner', filterPreSelect: false },
            { type: 'topper', text: 'Topper', filterPreSelect: true },
            { type: 'special_newsletter', text: 'Spezial-Newsletter', filterPreSelect: true },
            { type: 'author_tip', text: 'Autor-Tipp', filterPreSelect: true },
            { type: 'celebrity_tip', text: 'Promi-Tipp', filterPreSelect: true },
            { type: 'content_tip', text: 'Content-Tipp', filterPreSelect: true },
            { type: 'reduction', text: 'Vergünstigung', filterPreSelect: true },
        ],
        error: null,
        collection: null,
        loaded: false,
    },
    mutations: {
        iconsCollection(state, col) {
            state.icons.collection = col;
        },
        iconsIsLoaded(state, loaded) {
            state.icons.loaded = loaded;
        },
        setIconsError(state, error) {
            state.icons.error = error;
        },

        eventInfoboxesCollection(state, col) {
            state.eventInfoboxes.collection = col;
        },
        eventInfoboxesLoaded(state, loaded) {
            state.eventInfoboxes.loaded = loaded;
        },
        
        collection(state, col) {
            state.collection = col;
            state.loaded = true;
        },
        isLoaded(state, loaded) {
            state.loaded = loaded;
        },
        setError(state, error) {
            state.error = error;
        },
    },
    actions: {
        async loadIcons({ commit, state }, { force = false } = {}) {
            if (state.icons.loaded && !force) {
                return;
            }
            commit('loading', true, { root: true });
            commit('iconsIsLoaded', false);
            const collection = new BannerIconCollection();
            commit('iconsCollection', collection);
            await collection.query();
            commit('iconsIsLoaded', true);
            commit('loading', false, { root: true });
        },

        async loadEventInfoboxes({ commit, state }, { force = false } = {}) {
            if (state.eventInfoboxes.loaded && !force) {
                return;
            }
            commit('loading', true, { root: true });
            commit('eventInfoboxesLoaded', false);
            const collection = new BannerCollection();
            commit('eventInfoboxesCollection', collection);
            collection
                .setFilter('type', ['infobox_event_submit', 'infobox_event_publish'], 'IN')
                .addRemoteSort([{ property: 'display_order' }, { property: 'id' }]);
            await collection.query();
            commit('eventInfoboxesLoaded', true);
            commit('loading', false, { root: true });
        },

        async load({ commit, state }, { force = false } = {}) {
            if (state.loaded && !force) {
                return;
            }
            commit('loading', true, { root: true });
            commit('isLoaded', false);
            const collection = new BannerCollection();
            commit('collection', collection);
            await collection.query();
            commit('loading', false, { root: true });
        },
    },
};
